export const VERTICAL_NAME = 'SERVICE_BOOKING';
